export enum ESettingsAffiliateBannerField {
  IMAGE = 'image',
  LINK = 'link',
  ENABLED = 'enabled',
  UPDATED_AT = 'updated_at',
}
